import { useContext, useMemo } from 'react';
import { SessionContext } from '@/context/SessionContext';
import { hasAnyPermission } from '@/lib/permissions';

/**
 * Права текущего администратора — приходят в /auth/me из старой админки
 * (см. MeController + PermissionChecker::grantedSlugs).
 *
 * can() принимает паттерны в том же виде, что и маршруты на сервере:
 * can('platform*.customers.list'). Нужен ХОТЯ БЫ один подходящий —
 * так же, как admin_api_permission со списком через запятую.
 */
export function usePermissions(): { can: (...patterns: string[]) => boolean; granted: string[] } {
  const session = useContext(SessionContext);
  const granted = useMemo(() => session?.user.permissions ?? [], [session]);

  return useMemo(
    () => ({
      granted,
      can: (...patterns: string[]) => hasAnyPermission(granted, patterns),
    }),
    [granted],
  );
}
